var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100vw h-100vh_76px"},[_c('div',{staticClass:"w-100 h-100 d-fx jc-c ai-c"},[_c('img',{staticClass:"w-100 h-100 xw-458px xh-489px",attrs:{"src":_vm.getImage("pageNotFound"),"alt":_vm.getImage("pageNotFound")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }